import Swiper from 'swiper';
import {Pagination, Autoplay} from 'swiper/modules';

const MOBILE_BREAKPOINT = 1024;

const initHeroScreen = () => {
	const components = document.querySelectorAll( 'section.hero-screen' );

	if ( !components.length ) {
		return;
	}

	components.forEach( ( component ) => {
		const allVideos = component.querySelectorAll( 'video' );

		const changeBtnLink = (i) => {
			const btn = component.querySelector( 'a.watch-more' );

			if ( !btn )
			{
				return;
			}

			const currentVideo = allVideos[i].closest( 'a' ).getAttribute( 'href' );
			btn.setAttribute( 'href', currentVideo );
		}

		changeBtnLink(0);

		component.querySelector( 'div.swiper-hero' ).classList.add( 'init' );

		if ( window.innerWidth >= MOBILE_BREAKPOINT )
		{
			const firstBtn = component.querySelector( 'p.watch-more' );

			setTimeout(() => {
				firstBtn.classList.add( 'visible' );
			}, 4000);
		}

		const swiper = new Swiper( '.swiper-hero', {
			modules: [Pagination, Autoplay],
			slidesPerView: 1,
			loop: true,
			pagination: {
				el: '.pagination',
				clickable: true,
				renderBullet: ( index, className ) => {
					return `<li class="${className}"><span>${++index}</span>${index}</li>`;
				},
			},
			autoplay: {
				delay: 6000,
				disableOnInteraction: false,
			},
			on: {
				slideChange: () => {
					if ( window.innerWidth >= MOBILE_BREAKPOINT )
					{
						allVideos.forEach( ( video, i ) => {
							const allBtns = component.querySelectorAll( 'p.watch-more' )

							allBtns.forEach( ( btn ) => btn.classList.remove( 'visible' ) );

							if ( i == swiper.realIndex )
							{
								const currentSlide = component.querySelector( 'li.swiper-slide-next' );
								const watchMore = currentSlide.querySelector( 'p.watch-more' );
								
								setTimeout( () => {
									watchMore.classList.add( 'visible' );
								}, 4000 );
							}
						} );
					}
					else
					{
						changeBtnLink(swiper.realIndex);
					}
				},
			},
		} );
	} );
};

export {
	initHeroScreen,
};
